import { seedRateUnits } from "../../units"

export const calculationModelOptions =
[
    { id: "omnia", name: "Omnia default" },
    { id: "establishment", name: "Establishment layers" },
    { id: "flat", name: "Flat rate" }
] as const

export const seedRateUnitOptions = seedRateUnits